// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'ai-assist';

export const Component = () => (
  <path d='M22.5 9.5a1 1 0 0 1 .993.883l.007.117v4a1 1 0 0 1-1.993.117L21.5 14.5v-4a1 1 0 0 1 1-1Zm-4-3a1 1 0 0 1 .993.883l.007.117v10a1 1 0 0 1-1.993.117L17.5 17.5v-10a1 1 0 0 1 1-1Zm-4-4a1 1 0 0 1 .993.883l.007.117v18a1 1 0 0 1-1.993.117L13.5 21.5v-18a1 1 0 0 1 1-1Zm-4 6a1 1 0 0 1 .993.883l.007.117v6a1 1 0 0 1-1.993.117L9.5 15.5v-6a1 1 0 0 1 1-1ZM6.5 5a1 1 0 0 1 .993.883L7.5 6v13a1 1 0 0 1-1.993.117L5.5 19V6a1 1 0 0 1 1-1Zm-4 5.5a1 1 0 0 1 .993.883l.007.117v2a1 1 0 0 1-1.993.117L1.5 13.5v-2a1 1 0 0 1 1-1Z' />
);

export const viewBox = '0 0 25 25';
